import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Number1 = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step1-line-a"
          d="M12 4a8 8 0 100 16 8 8 0 000-16zm0 1.333a6.667 6.667 0 110 13.334 6.667 6.667 0 010-13.334zM13.544 16V8.147H12.18l-2.53 2.015.8.999.903-.725c.107-.086.299-.267.574-.543l-.027.816-.016.747V16h1.66z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="step1-line-b" fill={props.color || theme.colors.grey700}>
          <use xlinkHref="#step1-line-a"></use>
        </mask>
        <use
          fill={props.color || theme.colors.grey700}
          fillRule="nonzero"
          xlinkHref="#step1-line-a"
        ></use>
        <g fill={props.color || theme.colors.grey700} mask="url(#step1-line-b)">
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step1-solid-a"
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm1.544 12V8.147H12.18l-2.53 2.015.8.999.903-.725c.107-.086.299-.267.574-.543l-.027.816-.016.747V16h1.66z"
        ></path>
      </defs>
      <g fill={props.color || theme.colors.grey700} fillRule="evenodd">
        <mask id="step1-solid-b" fill={props.color || theme.colors.grey700}>
          <use xlinkHref="#step1-solid-a"></use>
        </mask>
        <use
          fill={props.color || theme.colors.grey700}
          fillRule="nonzero"
          xlinkHref="#step1-solid-a"
        ></use>
        <g
          fill={props.color || theme.colors.grey700}
          mask="url(#step1-solid-b)"
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  );
